// initial state
const state = () => ({
  orientations: [],
  activeOrientation: undefined,
  defaultOrientation: undefined,
  emptyOption: {
    value: "",
    label: "Choose Orientation",
  },
});

// getters
const getters = {
  getOrientations: (state) => {
    return state.orientations;
  },
  getActiveOrientation: (state) => {
    return state.activeOrientation;
  },
  getDefaultOrientation: (state) => {
    return state.defaultOrientation;
  },
  getEmptyOption: (state) => {
    return state.emptyOption;
  },
  getMatchingOrientation: (state) => (orientation) => {
    return state.orientations.find((option) => option === orientation);
  },
};

// actions
const actions = {
  setOrientations({ commit }, orientations) {
    commit("setOrientations", { orientations });
  },
  activateOrientation({ commit }, newOrientation) {
    commit("setActiveOrientation", newOrientation);
  },
  setDefaultOrientation({ commit }, orientation) {
    commit("setDefaultOrientation", orientation);
  },
};

// mutations
const mutations = {
  setOrientations(state, { orientations }) {
    state.orientations = [...orientations];
  },
  setActiveOrientation(state, newOrientation) {
    state.activeOrientation = newOrientation;
  },
  setDefaultOrientation(state, defaultOrientation) {
    state.defaultOrientation = defaultOrientation;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
